import { forwardRef } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import type { TelemetryProps } from "@Components/Modules/Helpers";
import { requestTrack } from "@Components/Modules/Helpers";
import type { IButtonV2 } from "@Layout/ButtonLink";
import { ButtonV2 } from "@Layout/ButtonLink";

export type ITelemetryButtonV2 = IButtonV2 & TelemetryProps;

const TelemetryButtonV2 = forwardRef<HTMLButtonElement, ITelemetryButtonV2>(
    ({ telemetryUrl, onClick, telemetryCustom, ...all }, ref) => {
        const clickTelemetry = (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            sendTelemetryEvent(telemetryCustom);

            requestTrack(telemetryUrl);

            if (onClick) {
                onClick(ev);
            }
        };

        return <ButtonV2 {...all} onClick={clickTelemetry} ref={ref} />;
    },
);

export default TelemetryButtonV2;
